import styles from "./addNotification.module.css";
import { Link } from "react-router-dom";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Autocomplete, FormControl, IconButton, InputLabel, MenuItem, Select, Slide, Snackbar, TextField, Typography } from "@mui/material";
import { ArrowLeft, Home, X } from "react-feather";
import { Editor } from "@tinymce/tinymce-react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import Loader from "../../components/Loader";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";

const schema = yup.object().shape({
  type: yup.string().required("This field is Required"),
  category: yup.string().required("This field is Required"),
  content: yup.string().when('type', {
    is: 'Email',
    then: (schema) => schema.required('This field is Required.'),
    otherwise: (schema) => schema.nullable(),
  }),
  content1: yup.string().when('type', {
    is: 'SMS',
    then: (schema) => schema.required('This field is Required.'),
    otherwise: (schema) => schema.nullable(),
  }),
  subject: yup.string().when('type', {
    is: 'Email',
    then: (schema) => schema.required('This field is Required.'),
    otherwise: (schema) => schema.nullable(),
  })
});

const AddEmailTemplate = ({ history, match }) => {
  const { getAccessTokenSilently } = useAuth0();
  const redirect = useHistory();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const editorRef = useRef(null);
  const { id } = match.params;
  const isAddMode = !id;

  useEffect(() => {
    const geNotificationList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/email-sms-category", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setCategoryList(response.data.data);
      }).catch(() => { });
    }

    geNotificationList();
  }, [getAccessTokenSilently]);

  const { errors, control, handleSubmit, setValue, clearErrors, watch } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      type: '',
      category: '',
      subject: '',
      content: '',
      content1: '',
    }
  });

  useEffect(() => {
    async function fetchData() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      axios.get(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents/" + id, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then((response) => {
        setValue("type", response.data.data?.type);
        setValue("category", response.data.data?.category);
        setValue("subject", response.data.data?.subject);
        setValue("content", response.data.data?.content);

        setSelectedType(response.data.data?.type);

        setTimeout(() => {
          setValue("content1", response.data.data?.content);
        }, 100);
      }).catch((error) => { });
    }

    if (id) {
      fetchData();
    }
  }, [id, getAccessTokenSilently, setValue]);

  const onSubmit = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    if (data?.logo_type === '')
      delete data?.logo_type;

    if (data?.type === 'SMS') {
      data = { ...data, content: data?.content1 };
    }
    delete data?.content1;

    axios.post(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents", data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg("Notification added successfully.");
      setSnackbarOpen(true);

      setTimeout(() => {
        redirect.push('/notification/email-sms-notification');
      }, 2000);

    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const onUpdate = async (data) => {
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    if (data?.logo_type === '')
      delete data?.logo_type;

    if (data?.type === 'SMS') {
      data = { ...data, content: data?.content1 };
    }

    delete data?.content1;

    axios.post(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents/" + id, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);
      setSnackbarMsg("Notification updated successfully.");
      setSnackbarOpen(true);

      setTimeout(() => {
        redirect.push('/notification/email-sms-notification');
      }, 2000);

    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const subjectValue = watch("subject");
  const contentValue = watch("content1");
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);

  const handleInsert = (token) => {
    const input = inputRef.current;
    if (!input) return;

    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newValue = subjectValue.slice(0, start) + token + subjectValue.slice(end);

    setValue("subject", newValue);

    setTimeout(() => {
      input.focus();
      const pos = start + token.length;
      input.setSelectionRange(pos, pos);
    }, 0);
  }

  const handleInsertC = (token) => {
    const input = inputRef2.current;
    if (!input) return;

    const start = input.selectionStart;
    const end = input.selectionEnd;
    const newValue = contentValue.slice(0, start) + token + contentValue.slice(end);

    setValue("content1", newValue);

    setTimeout(() => {
      input.focus();
      const pos = start + token.length;
      input.setSelectionRange(pos, pos);
    }, 0);
  }

  return (<>
    <Helmet title="Add Notification" />

    {loading && <Loader />}

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.SMProCusRow}`}>
        <div className={`${styles.BreadcrumbHeadSec}`}>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Notification</li>
              <li className={`${styles.breadcrumbItem}`}>
                <Link to={"/notification/email-sms-notification"}>Manage Notification</Link>
              </li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>{isAddMode ? 'Add Notification' : 'Edit Notification'}</li>
            </ol>
          </nav>
          <div className={`${styles.PageTitleSec}`}>
            <div>
              <Link to={`/notification/email-sms-notification`} className={`${styles.BackArrow}`}>
                <ArrowLeft />
              </Link>
              <Typography display="inline" className={`${styles.pageTitle}`}>{isAddMode ? 'Add Notification' : 'Edit Notification'}</Typography>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit(isAddMode ? onSubmit : onUpdate)}>
          <div className={`${styles.EmailTemplateBodySec}`}>
            <div className={`${styles.AddLeaseSection}`}>
              <div className={`${styles.AddDocTitleSec}`}>
                <div className={`${styles.FormGroupAddLeaseType} FormGroup`}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                    <Controller
                      name="type"
                      control={control}
                      render={(field) => (<Select
                        {...field}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Type"
                        onChange={(e) => {
                          field.onChange(e);
                          setSelectedType(e.target.value);

                          setValue('category', '');
                          clearErrors();
                        }}
                        disabled={!isAddMode}
                      >
                        <MenuItem value="Email">Email</MenuItem>
                        <MenuItem value="SMS">SMS</MenuItem>
                      </Select>)}
                    />
                    {errors?.type && (<p className={`${styles.ErrorM}`}>{errors?.type?.message}</p>)}
                  </FormControl>
                </div>
                <div className={`${styles.FormGroupAddLease} FormGroup`}>
                  <Controller
                    name={`category`}
                    control={control}
                    render={(field) => (<Autocomplete
                      value={field?.value ? field?.value : ""}
                      disableClearable
                      openOnFocus
                      freeSolo
                      options={selectedType !== '' ? categoryList?.filter(i => i?.type === selectedType) : [{ label: 'Select type first', is_disabled: 1 }]}
                      getOptionDisabled={(option) => parseInt(option?.is_disabled) > 0}
                      onChange={(event, newValue) => {
                        setValue('category', newValue?.label);
                        clearErrors();
                      }}
                      onInputChange={(event, newInputValue) => {
                        setValue('category', newInputValue);
                        clearErrors();
                      }}
                      renderInput={(params) => <TextField {...params} label="Title" />}
                      disabled={!isAddMode}
                    />)}
                  />
                  {errors.category && (<p className={`${styles.ErrorM}`}>{errors?.category?.message}</p>)}
                </div>
                {selectedType !== 'SMS' && <div className={`${styles.FormGroupAddLeaseFull} FormGroup`}>
                  <Controller
                    name="subject"
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Subject" variant="outlined" inputRef={inputRef} />)}
                  />
                  <div className={`${styles.SelectBUSec}`}>
                    <span onClick={(e) => handleInsert('{{PropertyName}}')}>Property Name</span>
                    <span onClick={(e) => handleInsert('{{ApartmentNo}}')}>Apartment</span>
                  </div>
                  {errors.subject && (<p className={`${styles.ErrorM}`}>{errors?.subject?.message}</p>)}
                </div>}

                {selectedType === 'SMS' && <div className={`${styles.FormGroupAddLeaseFull} FormGroup`}>
                  <Controller
                    name="content1"
                    control={control}
                    render={(field) => (<TextField {...field} id="outlined-basic" label="Message Body" variant="outlined" inputRef={inputRef2} multiline minRows={3} />)}
                  />
                  <div className={`${styles.SelectBUSec}`}>
                    <span onClick={(e) => handleInsertC('{{PropertyName}}')}>Property Name</span>
                    <span onClick={(e) => handleInsertC('{{ApartmentNo}}')}>Apartment</span>
                  </div>
                  {errors.content1 && (<p className={`${styles.ErrorM}`}>{errors?.content1?.message}</p>)}
                </div>}
              </div>
              {selectedType !== 'SMS' && <div className={`${styles.FormGroupTextareaFull}`}>
                <label className={`${styles.FilterLabel}`}>Description<span className={`${styles.errorSpan}`}>*</span></label>
                <Controller
                  name="content"
                  control={control}
                  render={(field) => (
                    <Editor
                      onInit={(evt, editor) => { editorRef.current = editor }}
                      className={`${styles.formControlTextArea}`}
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={field?.value}
                      init={{
                        height: 500,
                        menubar: false,
                        plugins: ["lists", "code", "table", "media", "image", "link"],
                        toolbar: [
                          "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor removeformat | alignleft aligncenter alignright alignjustify | numlist bullist link | image | code",
                          "property_name apartment_name apartment_type prospect_name prospect_email prospect_phone date application_fee custom_link"
                        ],
                        setup: (editor) => {
                          editor.ui.registry.addButton("property_name", {
                            text: "Property",
                            onAction: () =>
                              editor.insertContent(`{{PropertyName}}`),
                          });
                          editor.ui.registry.addButton("apartment_name", {
                            text: "Apartment",
                            onAction: () =>
                              editor.insertContent(`{{ApartmentName}}`),
                          });
                          editor.ui.registry.addButton("apartment_type", {
                            text: "Apartment Type",
                            onAction: () =>
                              editor.insertContent(`{{ApartmentType}}`),
                          });
                          editor.ui.registry.addButton("prospect_name", {
                            text: "Prospect/Tenant Name",
                            onAction: () =>
                              editor.insertContent(`{{ProspectName}}`),
                          });
                          editor.ui.registry.addButton("prospect_email", {
                            text: "Prospect Email",
                            onAction: () =>
                              editor.insertContent(`{{ProspectEmail}}`),
                          });
                          editor.ui.registry.addButton("prospect_phone", {
                            text: "Prospect Phone",
                            onAction: () =>
                              editor.insertContent(`{{ProspectPhone}}`),
                          });
                          editor.ui.registry.addButton("date", {
                            text: "Date",
                            onAction: () =>
                              editor.insertContent(`{{Date}}`),
                          });
                          editor.ui.registry.addButton("application_fee", {
                            text: "Application Fee",
                            onAction: () =>
                              editor.insertContent(`{{ApplicationFee}}`),
                          });
                          editor.ui.registry.addButton("custom_link", {
                            text: "Link",
                            onAction: () => {
                              const selectedText = editor.selection.getContent({ format: "text" });

                              if (!selectedText) {
                                editor.notificationManager.open({
                                  text: "Please select some text first.",
                                  type: "warning",
                                });
                                return;
                              }

                              const targetUrl = `{{ApplicationLink}}`;

                              // Wrap selected text in link
                              const linkHtml = `<a href="${targetUrl}" target="_blank" style="color: blue; text-decoration: underline;">${selectedText}</a>`;
                              editor.selection.setContent(linkHtml);
                            },
                          });
                        }
                      }}
                      onEditorChange={(e) => field.onChange(e)}
                    />
                  )}
                />
                {errors.content && (<p className={`${styles.ErrorM}`}>{errors.content.message}</p>)}
              </div>}
              <div className={`${styles.ButtonAction}`}>
                <button className={`${styles.CancelPopupBU}`} type="button" onClick={(e) => redirect.push("/notification/email-sms-notification")}>Cancel</button>
                <button className={`${styles.SubmitPopupBU}`} type="submit">{isAddMode ? 'Add' : 'Update'}</button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>)
}

export default withCustomAuthenticationRequired(AddEmailTemplate, {
  onRedirecting: () => <Loader />,
});
